<template>
  <b-row class="my-3">
    <b-col class="col-12 col-md-10 col-lg-8">
      <b-card v-if="!sent">
        <div v-html="title"></div>
        <p>{{ trans('client_type_in_email_or_mobile') }}</p>
        <b-form-group>
          <b-input
            v-model="email_or_mobile"
            name="email"
            placeholder="harry@hogwartsrec.com, 555-123-1234"
            :disabled="busy"
            @keydown="onRequestKeydown"
          />
        </b-form-group>
        <p v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </p>
        <p v-if="error" class="text-danger">
          {{ error }}
        </p>
        <b-row>
          <b-col>
            <b-button variant="branded" @click="onRequest" :disabled="busy || !canRequest">
              {{ trans('submit') }}
            </b-button>
          </b-col>
          <b-col v-if="adminCanChooseClient" class="col-auto">
            <b-button
              variant="outline-danger"
              :disabled="busy"
              v-b-modal.admin-choose-client-modal
            >
              <i class="fa fa-fw fa-user"></i>
              {{ trans('choose_a_client') }}
            </b-button>
            <admin-choose-client-modal
              :organization="organization"
              :type="type"
              @chosen="onClientChosen"
            ></admin-choose-client-modal>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="sent">
        <p>{{ trans('client_code_sent') }}</p>
        <b-form-group>
          <b-input
            v-model="code"
            :placeholder="trans('six_digit_code')"
            :disabled="busy"
            @keydown="onVerifyKeydown"
          />
        </b-form-group>
        <p v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </p>
        <p v-if="error" class="text-danger">
          {{ error }}
        </p>
        <div>
          <b-button variant="branded" @click="onVerify" :disabled="busy || !canVerify">
            {{ trans('submit') }}
          </b-button>
        </div>
        <div>
          <b-button variant="link" class="pl-0" @click="sent = !sent; code = null" :disabled="busy">
            {{ trans('send_again') }}?
          </b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import AdminChooseClientModal from './AdminChooseClientModal'

  export default {
    props: {
      organization: Object,
      reloadOnSuccess: {
        type: Boolean,
        default: true,
      },
      invoice: Object,
      title: {
        type: String,
        default: trans('client_not_connected'),
      },
      type: {
        type: String,
        default: 'client',
      },
    },
    components: {
      AdminChooseClientModal,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        email_or_mobile: null,
        code: null,
        sent: false,
      }
    },
    computed: {
      canRequest() {
        return !!this.email_or_mobile
      },
      canVerify() {
        return !!this.code && (this.code.length == 6 || this.code.length == 7)
      },
      verifyUrl() {
        if (!this.invoice) return `${_.iframeUrlPrefix}/org/${this.organization.id}/client/confirm`
        return `/org/${this.organization.id}/cart/connect_confirm`
      },
      adminCanChooseClient() {
        return this.organization.auth_user &&
          this.organization.auth_user.can_connect_as_client
      },
    },
    methods: {
      onRequestKeydown(e) {
        if (e.keyCode == 13 && this.canRequest) this.onRequest()
      },
      onRequest() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/connect`
        axios.post(url, {
          email_or_mobile: this.email_or_mobile,
        })
        .then(response => {
          this.busy = false
          this.sent = true
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onVerifyKeydown(e) {
        if (e.keyCode == 13 && this.canVerify) this.onVerify()
      },
      onVerify() {
        this.busy = true
        this.error = null
        axios.post(this.verifyUrl, {
          code: this.code.replace('-', '').replace(' ', ''),
        })
        .then(response => {
          if (this.reloadOnSuccess) {
            let url = _.maybeAddSession(window.location.href, this.organization)
            window.location.href = url
          }
          this.$emit('connected', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onClientChosen(client) {
        this.busy = false
        this.error = null
        let recipient_id = client.recipient_id || client.id
        let url = `/org/${this.organization.id}/client/impersonate/${recipient_id}`
        if (!!this.invoice) url = `/org/${this.organization.id}/cart/choose_client/${recipient_id}`
        axios.post(url)
        .then(response => {
          if (this.reloadOnSuccess) {
            window.location.reload()
          }
          this.$emit('connected', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.connect = this
    },
  }
</script>